module.exports = __webpack_public_path__ + "assets/images/jr_logo.ada08e1.svg";